var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_135496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.28 124.656C190.02 124.657 189.759 124.635 189.502 124.591C188.277 124.386 187.182 123.704 186.46 122.693C185.737 121.682 185.446 120.426 185.649 119.2L190.337 91.075C190.519 89.9789 191.085 88.9831 191.933 88.2654C192.781 87.5476 193.857 87.1545 194.968 87.1563H223.093C224.336 87.1563 225.528 87.6501 226.407 88.5292C227.287 89.4083 227.78 90.6006 227.78 91.8438C227.78 93.087 227.287 94.2792 226.407 95.1583C225.528 96.0374 224.336 96.5313 223.093 96.5313H198.943L194.902 120.738C194.72 121.832 194.156 122.827 193.31 123.544C192.463 124.262 191.39 124.656 190.28 124.656Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.557 116.809C226.118 116.328 225.583 115.944 224.988 115.681C224.392 115.418 223.748 115.282 223.097 115.281H157.472C156.819 115.279 156.173 115.412 155.575 115.674C154.977 115.935 154.44 116.319 153.999 116.8C153.558 117.281 153.222 117.849 153.013 118.467C152.804 119.085 152.726 119.741 152.785 120.391L162.16 223.516C162.265 224.684 162.805 225.771 163.673 226.561C164.541 227.351 165.674 227.786 166.847 227.781H213.722C214.896 227.786 216.028 227.351 216.896 226.561C217.764 225.771 218.304 224.684 218.41 223.516L227.785 120.391C227.84 119.741 227.76 119.087 227.548 118.471C227.337 117.854 226.999 117.288 226.557 116.809Z",
    fill: "#C4C4C4",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M176.219 199.656H91.8438C90.6005 199.656 89.4083 200.15 88.5292 201.029C87.6501 201.908 87.1562 203.101 87.1562 204.344C87.1562 210.56 89.6256 216.521 94.0209 220.917C98.4163 225.312 104.378 227.781 110.594 227.781H157.469C163.685 227.781 169.646 225.312 174.042 220.917C178.437 216.521 180.906 210.56 180.906 204.344C180.906 203.101 180.412 201.908 179.533 201.029C178.654 200.15 177.462 199.656 176.219 199.656Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M176.219 180.906H91.8438C90.6005 180.906 89.4083 180.412 88.5292 179.533C87.6501 178.654 87.1562 177.462 87.1562 176.219C87.1562 170.003 89.6256 164.041 94.0209 159.646C98.4163 155.251 104.378 152.781 110.594 152.781H157.469C163.685 152.781 169.646 155.251 174.042 159.646C178.437 164.041 180.906 170.003 180.906 176.219C180.906 177.462 180.412 178.654 179.533 179.533C178.654 180.412 177.462 180.906 176.219 180.906Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.906 180.906H87.1562C81.9786 180.906 77.7812 185.104 77.7812 190.281C77.7812 195.459 81.9786 199.656 87.1562 199.656H180.906C186.084 199.656 190.281 195.459 190.281 190.281C190.281 185.104 186.084 180.906 180.906 180.906Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_135496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(77.7812 77.7812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodPackage);
export default __webpack_public_path__ + "static/media/food-package.cf7528973f1d6b8306823923d9e79c5f.svg";
export { ForwardRef as ReactComponent };